import type { PaymentMethod } from "@wbly/data-storefront";
import styles from "./PaymentIcons.module.css";

type PaymentIconsProps = {
  paymentMethods: PaymentMethod[];
};

const { list, icon } = styles;

export function PaymentIcons({ paymentMethods }: PaymentIconsProps) {
  return (
    <div className={list}>
      {paymentMethods.map(({ image, alt, id }) => (
        <img key={id} src={image} alt={alt} className={icon} />
      ))}
    </div>
  );
}
